import { AccountInfoRoutes } from '../../pages/account-info/constants/routes';
import { ArcRoutes } from '../../pages/arc/constants/routes';
import { EmployeeContext } from '../models/app-context-model';
import { TCSMQuickNavigationLink, TcsmSiteSettingsProps } from '../models/epi-model';
import { NavigationOption } from '../models/generic-models';


export interface NavOverwrites {
	matchPath: string,
	overwritePath: string,
	hide: boolean,
}

const EeCompNavEn = (baseRoute: string): NavigationOption[] => {
	return [
		{
			value: `${baseRoute}${AccountInfoRoutes.PersonalInfoSegment}`,
			text: 'Personal Information',
			deepLink: false,
		},
		{
			value: `${baseRoute}${AccountInfoRoutes.RelationshipsSegment}`,
			text: 'Relationships',
			deepLink: false,
		},
		{
			value: `${baseRoute}${ArcRoutes.Compensation}`,
			text: 'Compensation',
			deepLink: false,
			employeeContext: [EmployeeContext.InstitutionEmployee],
		},
		{
			value: `${baseRoute}${ArcRoutes.Employment}`,
			text: 'Employment',
			deepLink: false,
			employeeContext: [EmployeeContext.InstitutionEmployee],
		},
		{
			value: `${baseRoute}${ArcRoutes.Coverage}`,
			text: 'Coverage',
			deepLink: false,
			employeeContext: [EmployeeContext.InstitutionEmployee, EmployeeContext.Participant],
			rolesMatch: 'MLPS.SeniorGroupPlanAdmin, MLPS.JuniorGroupPlanAdmin',
		},
		{
			value: `${baseRoute}${ArcRoutes.PensionEnrollment}`,
			text: 'Pension',
			deepLink: false,
			employeeContext: [EmployeeContext.InstitutionEmployee],
		},
		{
			value: `${baseRoute}${ArcRoutes.DocumentUpload}`,
			text: 'Document Upload',
			deepLink: false,
			employeeContext: [EmployeeContext.InstitutionEmployee],
		},


		{
			value: `${baseRoute}${ArcRoutes.CompensationEmployment}`,
			text: 'Employment & Compensation',
			deepLink: false,
			employeeContext: [EmployeeContext.Participant],
		},
		//{
		//	value: `${baseRoute}/TBD`,
		//	text: 'Account History',
		//	deepLink: false,
		//employeeContext: [EmployeeContext.InstitutionEmployee],

		//},
	];
};

const EeCompNavEs = (baseRoute: string): NavigationOption[] => {
	return [
		{
			value: `${baseRoute}${AccountInfoRoutes.PersonalInfoSegment}`,
			text: 'Información Personal',
			deepLink: false,
		},
		{
			value: `${baseRoute}${AccountInfoRoutes.RelationshipsSegment}`,
			text: 'Relaciones',
			deepLink: false,
		},
		{
			value: `${baseRoute}${ArcRoutes.ArcRoot}${ArcRoutes.Compensation}`,
			text: 'Compensación',
			deepLink: false,
			employeeContext: [EmployeeContext.InstitutionEmployee],
		},
		{
			value: `${baseRoute}${ArcRoutes.ArcRoot}${ArcRoutes.Employment}`,
			text: 'Empleo',
			deepLink: false,
			employeeContext: [EmployeeContext.InstitutionEmployee],
		},
		{
			value: `${baseRoute}${ArcRoutes.Coverage}`,
			text: 'Cobertura',
			deepLink: false,
			employeeContext: [EmployeeContext.InstitutionEmployee, EmployeeContext.Participant],
			rolesMatch: 'MLPS.SeniorGroupPlanAdmin, MLPS.JuniorGroupPlanAdmin',
		},
		{
			value: `${baseRoute}${ArcRoutes.PensionEnrollment}`,
			text: 'Pensión',
			deepLink: false,
			employeeContext: [EmployeeContext.InstitutionEmployee],
		},

		{
			value: `${baseRoute}${ArcRoutes.DocumentUpload}`,
			text: 'Carga de documentos',
			deepLink: false,
			employeeContext: [EmployeeContext.InstitutionEmployee],
		},


		{
			value: `${baseRoute}${ArcRoutes.CompensationEmployment}`,
			text: 'Compensación & Laboral',
			deepLink: false,
			employeeContext: [EmployeeContext.Participant],
		},
		//{
		//	value: `${baseRoute}/TBD`,
		//	text: 'Historial de cuenta',
		//	deepLink: false,
		//  employeeContext: [EmployeeContext.InstitutionEmployee],
		//},
	];
};

const GroupsNavEn = (baseRoute: string): NavigationOption[] => {
	return [
		{
			value: `${baseRoute}${ArcRoutes.BillingAccountsSearch}`,
			text: 'Billing Accounts',
			deepLink: false,
		},
		{
			value: `${baseRoute}${ArcRoutes.GroupAdministrators}`,
			text: 'Administrators',
			deepLink: false,
			fallbackMatch: `${baseRoute}${ArcRoutes.GroupAdminAdd}`,
		},
		{
			value: `${baseRoute}${ArcRoutes.ReportsBenefitsGroup}`,
			text: 'Reports',
			deepLink: false,
		},
		{
			value: `${baseRoute}${ArcRoutes.GroupDownloads}`,
			text: 'Downloads',
			deepLink: false,
		},
	];
};

const GroupsNavSp = (baseRoute: string): NavigationOption[] => {
	return [
		{
			value: `${baseRoute}${ArcRoutes.BillingAccountsSearch}`,
			text: 'Cuentas de facturación',
			deepLink: false,
		},
		{
			value: `${baseRoute}${ArcRoutes.GroupAdministrators}`,
			text: 'Administradores',
			deepLink: false,
			fallbackMatch: `${baseRoute}${ArcRoutes.GroupAdminAdd}`,
		},
		{
			value: `${baseRoute}${ArcRoutes.ReportsBenefitsGroup}`,
			text: 'Reportes',
			deepLink: false,
		},
		{
			value: `${baseRoute}${ArcRoutes.GroupDownloads}`,
			text: 'Descargas',
			deepLink: false,
		},
	];
};

const InstitutionNavEn = (baseRoute: string): NavigationOption[] => {
	return [
		{
			value: `${baseRoute}${ArcRoutes.InstitutionDetails}`,
			text: 'Details',
			deepLink: false,
		},
		{
			value: `${baseRoute}${ArcRoutes.InstitutionSurvey}`,
			text: 'Description',
			deepLink: false,
		},
		{
			value: `${baseRoute}${ArcRoutes.InstitutionAdministratorSearch}`,
			text: 'Institution Administrators',
			deepLink: false,
		},
		{
			value: `${baseRoute}${ArcRoutes.PlanSummary}`,
			text: 'Pension Plan',
			deepLink: false,
		},
		{
			value: `${baseRoute}${ArcRoutes.Compensation}`,
			text: 'Compensation',
			deepLink: false,
		},
		{
			value: `${baseRoute}${ArcRoutes.ReportsInstitution}`,
			text: 'Reports',
			deepLink: false,
		},
		{
			value: `${baseRoute}${ArcRoutes.AuditLog}`,
			text: 'Audit Log',
			deepLink: false,
		},
	];
};

const InstitutionNavSp = (baseRoute: string): NavigationOption[] => {
	return [
		{
			value: `${baseRoute}${ArcRoutes.InstitutionDetails}`,
			text: 'Detalles',
			deepLink: false,
		},
		{
			value: `${baseRoute}${ArcRoutes.InstitutionSurvey}`,
			text: 'Descripción',
			deepLink: false,
		},
		{
			value: `${baseRoute}${ArcRoutes.InstitutionAdministratorSearch}`,
			text: 'Administradores de instituciones',
			deepLink: false,
		},
		{
			value: `${baseRoute}${ArcRoutes.PlanSummary}`,
			text: 'Plan de pensión',
			deepLink: false,
		},
		{
			value: `${baseRoute}${ArcRoutes.Compensation}`,
			text: 'Compensación',
			deepLink: false,
		},
		{
			value: `${baseRoute}${ArcRoutes.ReportsInstitution}`,
			text: 'Reportes',
			deepLink: false,
		},
		{
			value: `${baseRoute}${ArcRoutes.AuditLog}`,
			text: 'Registro de auditoría',
			deepLink: false,
		},
	];
};

export const BillingAccountsNavEn = (baseRoute: string): NavigationOption[] => {
	return [
		{
			value: `${baseRoute}${ArcRoutes.Participants}`,
			text: 'Participants',
			deepLink: false,
		},
		{
			value: `${baseRoute}${ArcRoutes.ReportsBillingAccount}`,
			text: 'Reports',
			deepLink: false,
		},
	];
};

export const BillingAccountsNavSp = (baseRoute: string): NavigationOption[] => {
	return [
		{
			value: `${baseRoute}${ArcRoutes.Participants}`,
			text: 'Participantes',
			deepLink: false,
		},
		{
			value: `${baseRoute}${ArcRoutes.ReportsBillingAccount}`,
			text: 'Reportes',
			deepLink: false,
		},
	];
};

function MapEmployeeContext(employeeContextString: string): EmployeeContext[] {

	if (employeeContextString?.length > 0) {
		const newContext: EmployeeContext[] = [];
		employeeContextString.split(',')?.forEach(i => newContext.push(EmployeeContext[i.trim()]));
		return newContext;
	}

	return null;
}

function GenerateQuickNavMenu(baseRoute: string, menuItems: TCSMQuickNavigationLink[], overwrites?: NavOverwrites[]): NavigationOption[] {

	const quickMenu: NavigationOption[] = [];

	if (menuItems?.length > 0) {
		menuItems.forEach(
			item => {

				const overwrite = overwrites?.find(a => a.matchPath === item.linkUrl);

				if (overwrite?.hide) return;

				quickMenu.push({
					text: item.linkText,
					fallbackMatch: item.fallbackMatch,
					value: overwrite?.overwritePath || `${baseRoute}${item.linkUrl}`,
					deepLink: item.deepLink,
					rolesMatch: item.rolesMatch,
					employeeContext: MapEmployeeContext(item.employeeContext),
				});
			});
	}

	return quickMenu;
}

export function GenerateAdminQuickNavMenu(baseRoute: string, language: string, siteSettings: TcsmSiteSettingsProps): NavigationOption[] {
	if (siteSettings?.adminQuickNavigationMenu?.length > 0) {
		return GenerateQuickNavMenu(baseRoute, siteSettings.adminQuickNavigationMenu);
	}

	return language === 'en' ? EeCompNavEn(baseRoute) : EeCompNavEs(baseRoute);
}

export function GenerateInstitutionQuickNavMenu(baseRoute: string, language: string, siteSettings: TcsmSiteSettingsProps, overwrites?: NavOverwrites[]): NavigationOption[] {
	if (siteSettings?.institutionQuickNavigationMenu?.length > 0) {
		return GenerateQuickNavMenu(baseRoute, siteSettings.institutionQuickNavigationMenu, overwrites);
	}

	return language === 'en' ? InstitutionNavEn(baseRoute) : InstitutionNavSp(baseRoute);
}

export function GenerateGroupsQuickNavMenu(baseRoute: string, language: string, siteSettings: TcsmSiteSettingsProps): NavigationOption[] {
	if (siteSettings?.groupsQuickNavigationMenu?.length > 0) {
		return GenerateQuickNavMenu(baseRoute, siteSettings.groupsQuickNavigationMenu);
	}

	return language === 'en' ? GroupsNavEn(baseRoute) : GroupsNavSp(baseRoute);
}

export function GenerateClergyBioQuickNavMenu(baseRoute: string, language: string, siteSettings: TcsmSiteSettingsProps): NavigationOption[] {
	if (siteSettings?.clergyBioQuickNavigationMenu?.length > 0) {
		return GenerateQuickNavMenu(baseRoute, siteSettings.clergyBioQuickNavigationMenu);
	}
	return [];
}
